<template>
  <v-card v-if="!loading">
    <v-alert
      v-model="successDialog"
      dismissable
      prominent
      type="success"
      transition="scale-transition"
    >
      Item successfully saved!
    </v-alert>
    <v-alert
      v-model="errorDialog"
      dismissible
      prominent
      type="error"
      transition="scale-transition"
    >
      Something went wrong
    </v-alert>
    <v-card-title>
      <span class="headline">{{ mfg.name }}</span>
    </v-card-title>
    <v-card-text>
      <v-text-field
        v-model="mfg.name"
        label="Name"
      />
      <v-select
        v-model="mfg.manufacturerType"
        label="Type"
        :items="manufacturerTypes"
      />
    </v-card-text>
    <v-card-actions>
      <v-btn
        color="blue darken-1"
        text
        ripple
        @click="save()"
      >
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ManufacturerEditForm',
  props: {
    mfgId: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    mfg: {},
    loading: true,
    successDialog: false,
    errorDialog: false,
    manufacturerTypes: [
      'MANUFACTURER',
      'ANTIQUE',
      'SHOP',
    ],
  }),
  mounted() {
    this.get({ url: '/manufacturers', id: this.mfgId }).then(
      (response) => {
        this.mfg = response.data;
      },
      (error) => {
        console.log(error);
      },
    );
    this.loading = false;
  },
  methods: {
    ...mapActions('apiClient', ['get', 'update']),
    save() {
      this.update({ url: '/manufacturers', body: this.mfg, id: this.mfg.manufacturerId }).then(
        (response) => {
          this.successDialog = true;
          this.mfg = response.data;
          setTimeout(() => {
            this.successDialog = false;
          }, 5000);
        },
        (error) => {
          this.errorDialog = true;
          console.log(error);
          setTimeout(() => {
            this.errorDialog = false;
          }, 5000);
        },
      );
    },
  },
};
</script>
